import { configureStore } from "@reduxjs/toolkit";

import userSlice from './user-slice';
import notificationSlice from "./notification-slice";
import backdropSlice from "./backdrop-slice";
import productSlice from "./products-slice";
import orderSlice from "./orders-slice";

import producttypeSlice from "./producttype-slice";
import logSlice from "./log-slice";
import filesSlice from "./files-slice";
import favoriteSlice from "./favorite-slice";


const store = configureStore({
  reducer: {
   user:userSlice.reducer,
   notification:notificationSlice.reducer,
   backdrop:backdropSlice.reducer,
   product:productSlice.reducer,
   order:orderSlice.reducer,
   producttype:producttypeSlice.reducer,
   log:logSlice.reducer,
   file:filesSlice.reducer,
   favorite:favoriteSlice.reducer
  },
});

export default store;
